module.exports = __webpack_public_path__ + "img/dianzisuo.4039dc5a.png";